import { render } from "./ModalEditRRIM.vue?vue&type=template&id=27be943c&scoped=true"
import script from "./ModalEditRRIM.vue?vue&type=script&lang=js"
export * from "./ModalEditRRIM.vue?vue&type=script&lang=js"

import "./ModalEditRRIM.vue?vue&type=style&index=0&id=27be943c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27be943c"]])

export default __exports__